import { SELECTED_STORE } from '../constants';

/**
 * @function getSelectedStoreLocationId
 * Returns the selected store location id from local storage
 *
 * @returns {string} locationId - The location id retrieved from Store Selector MFE's local storage
 */

const getSelectedStoreLocationId = () => {
  try {
    const selectedLocationId = window.localStorage.getItem(SELECTED_STORE);
    const { id: locationId = '' } = JSON.parse(selectedLocationId);
    return locationId;
  } catch (e) {
    return '';
  }
};

export default getSelectedStoreLocationId;
